import { render, staticRenderFns } from "./AvatarSelection.vue?vue&type=template&id=12de4b69&"
import script from "./AvatarSelection.vue?vue&type=script&lang=js&"
export * from "./AvatarSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12de4b69')) {
      api.createRecord('12de4b69', component.options)
    } else {
      api.reload('12de4b69', component.options)
    }
    module.hot.accept("./AvatarSelection.vue?vue&type=template&id=12de4b69&", function () {
      api.rerender('12de4b69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AvatarSelection.vue"
export default component.exports